import {endpoint} from '~/api';
import {ID} from '~/lib/model';
import {IAppAds, IAppAdsDownloadEntry, IAppAdsMissingLine} from '~/modules/AppAds/models/app-ads';
import { ILine } from "~/modules/Clients/models/Line";

export const fetchSellerAppAds = (sellerId: ID) => endpoint.get<IAppAds>(`/sellers/${sellerId}/app-ads`).then(r => ({
    ...r.data,
    sellerId: sellerId
})).catch(() => null);

export const fetchAppAds = () => endpoint.get<IAppAds>('/app-ads').then(r => ({
    ...r.data
})).catch(() => null);

export const updateAppAds = (appAds: IAppAds) => endpoint.post('/app-ads', appAds).then(r => r.data);

export const fetchAppAdsDownloadHistory = () => endpoint.get<IAppAdsDownloadEntry[]>('/app-ads/download-history').then(r => r.data);

export const updateAppAdsLastDownload = (sellerId: ID) => endpoint.post(`/sellers/${sellerId}/app-ads/download-history`).then(r => r.data);

export const fetchSellerDomains = (sellerId: ID) => endpoint.get<string[]>(`/sellers/${sellerId}/domains`).then(r => r.data);

export const fetchDistributionLinesByDomain = (domain: string, publisherId: ID) =>
  endpoint.get<ILine[]>(`/sellers/${publisherId}/app-ads/v2`, {
    params: { domain }
  }).then(r => r.data);

export const fetchDistributionLinesByPublisher = (publisherId: ID) =>
  endpoint.get<ILine[]>(`/sellers/${publisherId}/app-ads/v2`).then(r => r.data);

export const fetchMissingLines = (sellerId: ID, domain: string) =>
  endpoint.get<IAppAdsMissingLine[]>(`/sellers/${sellerId}/app-ads/missing-lines`, {
    params: { domain }
  }).then(r => r.data);

export const fetchMismatchedLines = (sellerId: ID, domain: string) =>
  endpoint.get<IAppAdsMissingLine[]>(`/sellers/${sellerId}/app-ads/mismatched-lines`, {
    params: { domain }
  }).then(r => r.data);
